'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { type FC, useMemo, useState } from 'react';
import { experienceTypesOptions } from '@/entities/Experiences/api/experienceTypes';
import { SearchSelect, type SearchSelectOption } from '../SearchSelect';
interface ActionTypeSearchSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  className?: string;
  allowClear?: boolean;
}
export const ActionTypeSearchSelect: FC<ActionTypeSearchSelectProps> = t0 => {
  const $ = _c(16);
  const {
    value,
    onChange,
    placeholder,
    className: t1,
    allowClear: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const allowClear = t2 === undefined ? true : t2;
  const [searchValue, setSearchValue] = useState("");
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = experienceTypesOptions();
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    data: t4
  } = useSuspenseQuery(t3);
  let t5;
  if ($[1] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const experienceTypesList = t5;
  let t6;
  bb0: {
    if (experienceTypesList.length > 0) {
      let t7;
      if ($[3] !== experienceTypesList) {
        t7 = experienceTypesList.map(_temp);
        $[3] = experienceTypesList;
        $[4] = t7;
      } else {
        t7 = $[4];
      }
      t6 = t7;
      break bb0;
    }
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = [];
      $[5] = t7;
    } else {
      t7 = $[5];
    }
    t6 = t7;
  }
  const selectOptions = t6;
  let t7;
  if ($[6] !== onChange) {
    t7 = value_0 => onChange(value_0.map(String));
    $[6] = onChange;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== allowClear || $[9] !== className || $[10] !== placeholder || $[11] !== searchValue || $[12] !== selectOptions || $[13] !== t7 || $[14] !== value) {
    t8 = <SearchSelect value={value} onChange={t7} placeholder={placeholder} className={className} options={selectOptions} searchValue={searchValue} setSearchValue={setSearchValue} allowClear={allowClear} filterOption={_temp2} />;
    $[8] = allowClear;
    $[9] = className;
    $[10] = placeholder;
    $[11] = searchValue;
    $[12] = selectOptions;
    $[13] = t7;
    $[14] = value;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(item) {
  return {
    value: item.type_name,
    label: item.type_name
  };
}
function _temp2(input, option) {
  return (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase());
}